import BaseModel from "~/models/BaseModel";

export default class UserAccountModel extends BaseModel {
  fullAddress() {
    return `${this.city}${this.address} ${this.addressBuilding}`;
  }
}
